import { config } from 'api';
import fetchAction from 'utils/fetchAction';

const url = `${config.apiBasePath}/tag-redirect-rules`;

export const FETCH_TAXONOMY_REDIRECTS_REQUEST = 'FETCH_TAXONOMY_REDIRECTS_REQUEST';
export const FETCH_TAXONOMY_REDIRECTS_SUCCESS = 'FETCH_TAXONOMY_REDIRECTS_SUCCESS';
export const FETCH_TAXONOMY_REDIRECTS_ERROR = 'FETCH_TAXONOMY_REDIRECTS_ERROR';

export const fetchTagRedirects = fetchAction({
  actions: [
    FETCH_TAXONOMY_REDIRECTS_REQUEST,
    FETCH_TAXONOMY_REDIRECTS_SUCCESS,
    FETCH_TAXONOMY_REDIRECTS_ERROR,
  ],
  url,
});
